import {useState} from 'react'

import {connect} from '../../../state/hooks/tools'
import {CLIENTS} from '../../../state/actionTypes'
import {createResource} from '../../../lib/asyncMethods'

import ClientForm from './ClientForm'
import CopyToClipboard from '../../shared/CopyToClipboard'
import Modal from '../../shared/Modal'

const NewClientController = props => {
  const [mode, setMode] = useState('create')
  const [secret, setSecret] = useState('')

  const handleSubmit = data => {
    props.createResource({endpoint: 'clients', attributes: data}).then(response => {
      if (response.success) {
        setSecret(response.data.secret)
        setMode('save')
      }
    })
  }

  return (
    <Modal
      disableBackdrop
      open={props.showModal}
      handleClose={props.toggleModal}
      disabled={props.loading}
      subHeading={
        mode === 'create' ?
          'Information about connected client services.' :
          'Please save the secret generated and share securely with the intended service.'
      }
      buttonText='Done'
      title={`${mode === 'create' ? 'New ' : ''}Client`}>
        {
          mode === 'create' ?
            <ClientForm handleSubmit={handleSubmit} /> :
            <CopyToClipboard height='200px' text={secret} />
        }
    </Modal>
  )
}

const actionCreators = ({clients}) => ({createResource: createResource(clients, CLIENTS)})

export default connect(null, actionCreators)(NewClientController)
